import { render, staticRenderFns } from "./JobErrorComponent.vue?vue&type=template&id=2f6f9817&scoped=true&"
import script from "./JobErrorComponent.vue?vue&type=script&lang=ts&"
export * from "./JobErrorComponent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f6f9817",
  null
  
)

export default component.exports